import { injectEspnFonts } from '../clients/DISNEY/espn/_brand-kit/font-loader';
import { injectHipotecarioFonts } from '../clients/HIPOTECARIO/_brand-kit/font-loader';
import { injectMacroFonts } from '../clients/MACRO/_brand-kit/font-loader';

type BrandAssetsLoader = () => void;

const BRAND_ASSETS_LOADERS: Record<string, BrandAssetsLoader> = {
  DISNEY: injectEspnFonts,
  HIPOTECARIO: injectHipotecarioFonts,
  MACRO: injectMacroFonts
};

export const loadBrandAssetsForClient = (clientId?: string): void => {
  if (!clientId) return;
  if (clientId === 'TEST') {
    Object.values(BRAND_ASSETS_LOADERS).forEach(load => load());
    return;
  }
  BRAND_ASSETS_LOADERS[clientId]?.();
};
